import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-up-red.svg'
import _imports_2 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_3 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'
import _imports_4 from '@/app/ui/assets/svg/info-red.svg'


const _hoisted_1 = { class: "\n      flex flex-row\n      justify-between\n      items-center\n      border-b border-gray-lp-400\n      z-20\n    " }
const _hoisted_2 = { class: "flex flex-row my-4" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout" }
const _hoisted_4 = { class: "inline-flex" }
const _hoisted_5 = { class: "w-10/12" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row mt-4 gap-x-4"
}
const _hoisted_7 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_8 = { class: "text-gray-lp-500 font-normal" }
const _hoisted_9 = {
  key: 0,
  class: "ml-1 relative"
}
const _hoisted_10 = {
  key: 1,
  class: "flex flex-row mt-4 gap-x-4"
}
const _hoisted_11 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_12 = { class: "text-gray-lp-500 font-normal" }
const _hoisted_13 = {
  key: 0,
  class: "ml-1 relative"
}
const _hoisted_14 = { class: "flex flex-col mt-4 gap-x-4" }
const _hoisted_15 = {
  class: "bg-white w-full rounded-xl p-6",
  style: {"border":"1px solid #EBEBEB"}
}
const _hoisted_16 = /*#__PURE__*/_createVNode("p", {
  class: "text-14px font-semibold xxl:text-16px",
  style: {"color":"#333"}
}, " Nama Klien ", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row justify-between border-b py-3 px-4" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Filter Pencarian klien "),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "w-4",
    alt: "up"
  })
], -1)
const _hoisted_18 = { class: "flex flex-col gap-y-4 p-4" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Kota asal klien (3LC) ", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Tipe Layanan Pengiriman ", -1)
const _hoisted_22 = { class: "gap-x-2 flex flex-row items-center w-full" }
const _hoisted_23 = { class: "flex pt-1 flex-row items-center" }
const _hoisted_24 = { class: "items-center w-full flex flex-wrap flex-row" }
const _hoisted_25 = { class: "bg-gray-lp-1100 flex flex-row items-center rounded px-2 py-1 mr-1 mb-2 whitespace-no-wrap" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_27 = { class: "flex flex-row mt-4 gap-x-4" }
const _hoisted_28 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_29 = { class: "text-gray-lp-500 font-normal" }
const _hoisted_30 = {
  key: 0,
  class: "ml-1 relative"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_32 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_33 = { class: "flex flex-row mt-4" }
const _hoisted_34 = { class: "w-full mr-4" }
const _hoisted_35 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_36 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_37 = { class: "w-full" }
const _hoisted_38 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_39 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_40 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_41 = { class: "flex flex-row mb-6 mt-0" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_43 = { class: "w-1/2 ml-6 flex flex-col" }
const _hoisted_44 = { class: "flex flex-row" }
const _hoisted_45 = { class: "flex flex-row" }
const _hoisted_46 = { class: "mx-2" }
const _hoisted_47 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_48 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_49 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_50 = {
  key: 2,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1"
}
const _hoisted_51 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1"
}
const _hoisted_52 = {
  key: 1,
  class: "\n              flex flex-row\n              items-start\n              rounded\n              bg-gray-lp-200\n              text-gray-lp-800 text-12px\n              xxl:text-14px\n              p-4\n              space-x-2\n              mt-2\n            "
}
const _hoisted_53 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  alt: "info red"
}, null, -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("div", null, "Untuk tujuan yang dipilih maksimal 1 koli", -1)
const _hoisted_55 = {
  key: 3,
  class: "flex flex-row my-6"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_57 = { class: "w-1/2 ml-6" }
const _hoisted_58 = { class: "flex flex-row text-12px xxl:text-14px relative" }
const _hoisted_59 = { class: "w-1/2 mr-4" }
const _hoisted_60 = { class: "p-field-checkbox mt-3" }
const _hoisted_61 = { class: "w-1/2" }
const _hoisted_62 = { class: "p-field-checkbox mt-3" }
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_64 = {
  key: 0,
  class: "flex text-red-lp-100 gap-1 mt-2"
}
const _hoisted_65 = { class: "text-14px" }
const _hoisted_66 = { class: "flex flex-row mt-4 space-x-4" }
const _hoisted_67 = { class: "w-1/2" }
const _hoisted_68 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_69 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_70 = { class: "ml-1 relative" }
const _hoisted_71 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-1000 flex gap-x-2 pl-1"
}
const _hoisted_72 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-4.5 max-w-none",
  alt: "exclamation triangle red"
}, null, -1)
const _hoisted_73 = { class: "flex flex-row text-12px xxl:text-14px relative mt-4 space-x-4" }
const _hoisted_74 = {
  key: 6,
  class: "flex flex-row text-12px xxl:text-14px relative mt-4 space-x-4"
}
const _hoisted_75 = { for: "cod" }
const _hoisted_76 = { class: "flex flex-row text-12px xxl:text-14px mt-4 space-x-4 items-center" }
const _hoisted_77 = { class: "w-1/2" }
const _hoisted_78 = { key: 7 }
const _hoisted_79 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_80 = { class: "flex flex-row mt-4" }
const _hoisted_81 = { class: "w-full mr-2" }
const _hoisted_82 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_83 = {
  key: 0,
  class: "text-red-lp-300 font-normal pl-1"
}
const _hoisted_84 = { class: "ml-1 relative" }
const _hoisted_85 = { class: "w-full ml-2" }
const _hoisted_86 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_87 = {
  key: 0,
  class: "text-red-lp-300 font-normal pl-1"
}
const _hoisted_88 = {
  key: 1,
  class: "text-gray-lp-500 font-normal"
}
const _hoisted_89 = { class: "ml-1 relative" }
const _hoisted_90 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-1000 flex gap-x-2 pl-1"
}
const _hoisted_91 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-4.5 max-w-none",
  alt: "exclamation triangle red"
}, null, -1)
const _hoisted_92 = {
  key: 0,
  class: "flex flex-row mt-4"
}
const _hoisted_93 = { class: "w-full mr-2" }
const _hoisted_94 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_95 = /*#__PURE__*/_createVNode("p", null, "Piece Per Pack", -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_97 = { class: "ml-1 relative" }
const _hoisted_98 = { class: "w-full ml-2" }
const _hoisted_99 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_100 = /*#__PURE__*/_createVNode("p", null, "Komoditas Selanjutnya", -1)
const _hoisted_101 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_102 = { class: "ml-1 relative" }
const _hoisted_103 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_104 = { class: "flex w-full flex-row gap-x-6" }
const _hoisted_105 = /*#__PURE__*/_createVNode("div", { class: "w-1/12 font-semibold text-12px xxl:text-14px text-center" }, " No ", -1)
const _hoisted_106 = { class: "w-40 font-semibold text-12px xxl:text-14px flex flex-row" }
const _hoisted_107 = /*#__PURE__*/_createVNode("span", { class: "font-normal text-gray-lp-500" }, " (kg)", -1)
const _hoisted_108 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_109 = { class: "relative" }
const _hoisted_110 = { class: "w-4/12 font-semibold text-12px xxl:text-14px" }
const _hoisted_111 = { class: "font-normal text-gray-lp-500" }
const _hoisted_112 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_113 = { class: "w-36 font-semibold text-14p text-center" }
const _hoisted_114 = { class: "w-full" }
const _hoisted_115 = /*#__PURE__*/_createVNode("div", { class: "border-t mt-4" }, null, -1)
const _hoisted_116 = { class: "flex flex-row items-center gap-x-6" }
const _hoisted_117 = { class: "w-1/12 text-12px xxl:text-14px font-montserrat text-center" }
const _hoisted_118 = { class: "w-40" }
const _hoisted_119 = { class: "w-4/12" }
const _hoisted_120 = { class: "w-36 text-12px xxl:text-14px font-montserrat text-center" }
const _hoisted_121 = { class: "w-20" }
const _hoisted_122 = {
  key: 0,
  class: "flex flex-row pl-5 pt-1"
}
const _hoisted_123 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_124 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_125 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_126 = {
  key: 0,
  class: "flex flex-row justify-start gap-x-6"
}
const _hoisted_127 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_128 = {
  style: {"border":"1px dashed #FAB713","background":"linear-gradient(180deg, #FEFAE8 0%, rgba(254, 250, 232, 0.00) 100%)"},
  class: "flex flex-row px-4 py-2 rounded-md mt-4 w-max"
}
const _hoisted_129 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 text-12px" }, null, -1)
const _hoisted_130 = {
  key: 9,
  class: "flex flex-row justify-between text-12px xxl:text-14px px-6 my-6"
}
const _hoisted_131 = { class: "flex flex-col justify-around w-full" }
const _hoisted_132 = { class: "\n              flex flex-row\n              justify-between\n              text-gray-lp-300\n              font-semibold\n              text-12px\n              xxl:text-14px\n            " }
const _hoisted_133 = { class: "flex flex-col" }
const _hoisted_134 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px"
}
const _hoisted_135 = /*#__PURE__*/_createTextVNode(" Promo Berat ")
const _hoisted_136 = { class: "flex flex-col" }
const _hoisted_137 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px"
}
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" Promo Berat ")
const _hoisted_139 = /*#__PURE__*/_createVNode("div", { class: "border-t-2 mt-4" }, null, -1)
const _hoisted_140 = { class: "\n              flex flex-row\n              justify-between\n              text-gray-lp-300\n              font-semibold\n              text-12px\n              xxl:text-14px\n              mt-4\n            " }
const _hoisted_141 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px"
}
const _hoisted_142 = { class: "text-14px pt-5 text-black-lp-300 font-bold" }
const _hoisted_143 = { class: "flex items-center justify-center py-3" }
const _hoisted_144 = { class: "text-gray-lp-600 line-through text-14px mr-3" }
const _hoisted_145 = { class: "text-red-lp-100 font-bold text-18px" }
const _hoisted_146 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_147 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row justify-between border-b py-3 px-4" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Filter Pencarian klien "),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "w-4",
    alt: "up"
  })
], -1)
const _hoisted_148 = { class: "flex flex-col gap-y-4 p-4" }
const _hoisted_149 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Kota asal klien (3LC) ", -1)
const _hoisted_150 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_151 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Tipe Layanan Pengiriman ", -1)
const _hoisted_152 = { class: "mt-5 flex relative w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailCalculation = _resolveComponent("DetailCalculation")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpInputSearch = _resolveComponent("LpInputSearch")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_WarningSlaTransportation = _resolveComponent("WarningSlaTransportation")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_BannerProductType = _resolveComponent("BannerProductType")!
  const _component_product_poster = _resolveComponent("product-poster")!
  const _component_Select = _resolveComponent("Select")!
  const _component_InfoInsurance = _resolveComponent("InfoInsurance")!
  const _component_Woodpacking = _resolveComponent("Woodpacking")!
  const _component_DeliveryTypeClient = _resolveComponent("DeliveryTypeClient")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_InformationCodRetail = _resolveComponent("InformationCodRetail")!
  const _component_AdditionalInfo = _resolveComponent("AdditionalInfo")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_UploadPhotoAdjustment = _resolveComponent("UploadPhotoAdjustment")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_card = _resolveComponent("card")!
  const _component_DialogPayment = _resolveComponent("DialogPayment")!
  const _component_Search = _resolveComponent("Search")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "w-5 mr-3 cursor-pointer",
          alt: "arrow-left"
        }),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getTitle), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.renderDetailCalculation)
          ? (_openBlock(), _createBlock(_component_DetailCalculation, {
              key: 0,
              isBooking: true,
              isDisabled: 
          _ctx.isDisabledButton ||
            _ctx.isErrorHws ||
            (_ctx.eligibleAdditionalInfo &&
              (_ctx.disableDetailCommodity || _ctx.disableProofCommodity))
        ,
              bookingType: _ctx.formType,
              payload: _ctx.payload,
              accountRefAndCommodity: _ctx.accountRefAndCommodity,
              formType: _ctx.formType,
              isCodRetail: _ctx.isCodRetailApplied,
              onUpdateStatusErrorEmbargo: _ctx.updateStatusErrorEmbargo,
              onSetDiscount: _ctx.setDiscount
            }, null, 8, ["isDisabled", "bookingType", "payload", "accountRefAndCommodity", "formType", "isCodRetail", "onUpdateStatusErrorEmbargo", "onSetDiscount"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(), _createBlock("div", {
      class: "w-full px-4 text-12px xxl:text-14px overflow-y-auto pb-20 mt-6",
      key: _ctx.reRenderManualBooking
    }, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Title, {
          label: _ctx.$t('bookingShipment.column.detailShipment')
        }, null, 8, ["label"]),
        (_ctx.formType === 'manual' && _ctx.getAccount.accountType === 'client')
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode(_component_DataWrapper, { class: "w-full mr-4" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.manualSttNumber")) + " ", 1),
                      _createVNode("span", _hoisted_8, "(" + _toDisplayString(_ctx.$t("optional")) + ")", 1)
                    ]),
                    (_ctx.formType === 'manual')
                      ? (_openBlock(), _createBlock("div", _hoisted_9, [
                          _createVNode("img", {
                            onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenTooltipManualSTT = true)),
                            onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpenTooltipManualSTT = false)),
                            src: 
                    _ctx.isOpenTooltipManualSTT
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                            alt: ""
                          }, null, 40, ["src"]),
                          _withDirectives(_createVNode(_component_Tooltip, {
                            title: _ctx.$t('bookingShipment.tooltip.manualStt'),
                            message: _ctx.$t('bookingShipment.tooltip.manualSttMsg'),
                            footer: "",
                            style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.6em"}
                          }, null, 8, ["title", "message"]), [
                            [_vShow, _ctx.isOpenTooltipManualSTT]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_lp_input, {
                    class: "my-2",
                    error: _ctx.error.sttManual,
                    errorCaption: _ctx.errorCaptionSttManual,
                    disabled: _ctx.isDisabledSttManual,
                    onChange: _ctx.validateSttManual,
                    modelValue: _ctx.manualBooking.sttManual,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.manualBooking.sttManual = $event))
                  }, null, 8, ["error", "errorCaption", "disabled", "onChange", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.column.externalRefNumber'),
                optional: !_ctx.isDO,
                asterisk: _ctx.isDO,
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.manualBooking.referenceExternal,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.manualBooking.referenceExternal = $event)),
                    placeholder: "DOR00989",
                    errorIcon: false,
                    errorCaption: _ctx.$t('bookingShipment.error.noRef'),
                    showMaxLength: true,
                    maxLength: 100,
                    error: _ctx.errorMandatory[2],
                    onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setFieldIndex(2)))
                  }, null, 8, ["modelValue", "errorCaption", "error"])
                ]),
                _: 1
              }, 8, ["label", "optional", "asterisk"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.formType === 'manual' && _ctx.getAccount.accountType === 'partner')
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode(_component_DataWrapper, { class: "w-full mr-4" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.manualSttNumber")) + " ", 1),
                      _createVNode("span", _hoisted_12, "(" + _toDisplayString(_ctx.$t("optional")) + ")", 1)
                    ]),
                    (_ctx.formType === 'manual')
                      ? (_openBlock(), _createBlock("div", _hoisted_13, [
                          _createVNode("img", {
                            onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isOpenTooltipManualSTT = true)),
                            onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isOpenTooltipManualSTT = false)),
                            src: 
                    _ctx.isOpenTooltipManualSTT
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                            alt: ""
                          }, null, 40, ["src"]),
                          _withDirectives(_createVNode(_component_Tooltip, {
                            title: _ctx.$t('bookingShipment.tooltip.manualStt'),
                            message: _ctx.$t('bookingShipment.tooltip.manualSttMsg'),
                            footer: "",
                            style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.6em"}
                          }, null, 8, ["title", "message"]), [
                            [_vShow, _ctx.isOpenTooltipManualSTT]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_lp_input, {
                    isFirstInput: true,
                    class: "my-2",
                    error: _ctx.error.sttManual,
                    errorCaption: _ctx.errorCaptionSttManual,
                    disabled: _ctx.isDisabledSttManual,
                    onChange: _ctx.validateSttManual,
                    modelValue: _ctx.manualBooking.sttManual,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.manualBooking.sttManual = $event))
                  }, null, 8, ["error", "errorCaption", "disabled", "onChange", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.column.externalRefNumber'),
                optional: true,
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.manualBooking.referenceExternal,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.manualBooking.referenceExternal = $event)),
                    placeholder: "DOR00989",
                    errorCaption: _ctx.$t('bookingShipment.error.noRef'),
                    showMaxLength: true,
                    maxLength: 100
                  }, null, 8, ["modelValue", "errorCaption"])
                ]),
                _: 1
              }, 8, ["label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.formType === 'client')
          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("div", {
                    class: 
                `flex flex-row items-center ${
                  _ctx.isErrorClient || _ctx.errorMandatory[0] ? 'mt-0' : 'mt-2'
                }`
              
                  }, [
                    _createVNode(_component_AdvancedFilter, {
                      "custom-max-height": "60vh",
                      "model-value": _ctx.filterClient,
                      isDisabled: false,
                      onOpened: _ctx.onOpenedAdvancedFilter,
                      onReset: ($event: any) => (
                  {
                  }
                ),
                      addSumFilter: _ctx.sumFilter,
                      showIconFilter: true,
                      showCountFilter: false,
                      showChevron: false,
                      isSeparateContent: "",
                      customTitleFilter: "text-14px font-semibold text-gray-lp-300"
                    }, {
                      "custom-filter": _withCtx(() => [
                        _hoisted_17,
                        _createVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_SelectSearchV2, {
                            onFilter: _ctx.fetchCityDestination,
                            onFocus: _ctx.fetchCityDestination,
                            isLoading: _ctx.loadingCityDestination,
                            options: _ctx.cityDestinationData,
                            keyName: "name",
                            keyValue: "name",
                            placeholder: "Ketik & pilih kota asal klien (3LC)",
                            modelValue: _ctx.filterClient.cityOriginCode,
                            "onUpdate:modelValue": [
                              _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterClient.cityOriginCode = $event)),
                              _ctx.onChangeCityDestination
                            ]
                          }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "modelValue", "onUpdate:modelValue"]),
                          _hoisted_20,
                          _hoisted_21,
                          _createVNode(_component_MultipleSelectSearch, {
                            onChange: _ctx.onChangeShipmentType,
                            status: "active",
                            class: "my-1.5",
                            options: _ctx.optionsProduct,
                            placeholder: "Pilih tipe layanan pengiriman",
                            modelValue: _ctx.filterClient.shipmentType,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.filterClient.shipmentType = $event))
                          }, null, 8, ["onChange", "options", "modelValue"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model-value", "onOpened", "addSumFilter"]),
                    _createVNode("div", _hoisted_22, [
                      _createVNode(_component_SelectSearch, {
                        isFirstInput: true,
                        options: _ctx.clients,
                        onFocus: _ctx.fetchClients,
                        onFilter: _ctx.filterClients,
                        keyName: "name",
                        keyValue: "id",
                        placeholder: "Ketik & pilih nama/kode klien cabang",
                        modelValue: _ctx.manualBooking.clientName,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.manualBooking.clientName = $event)),
                        isLoading: _ctx.isLoadingClients,
                        onChange: _ctx.getClientStatus,
                        isShowErrorMessage: false,
                        isShowErrorIndicator: _ctx.isErrorClient || _ctx.errorMandatory[0],
                        errorCaption: 
                    _ctx.errorMandatory[0]
                      ? 'Nama client wajib diisi'
                      : 'Client tidak dapat melakukan booking'
                  ,
                        class: [_ctx.isErrorClient || _ctx.errorMandatory[0] ? 'mt-8' : 'my-2', "w-full"]
                      }, null, 8, ["options", "onFocus", "onFilter", "modelValue", "isLoading", "onChange", "isShowErrorIndicator", "errorCaption", "class"]),
                      _createVNode(_component_button_outline, {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onShowPopupFilterClient(true))),
                        title: "Direktori Klien",
                        custom: "w-48 border-gray-lp-600 text-gray-lp-300 bg-white",
                        style: {"height":"40px"},
                        class: "mr-4"
                      })
                    ])
                  ], 2),
                  _createVNode("div", _hoisted_23, [
                    _createVNode("div", _hoisted_24, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summaryFilter, (item, index) => {
                        return (_openBlock(), _createBlock("div", { key: index }, [
                          _createVNode("div", _hoisted_25, [
                            _createTextVNode(_toDisplayString(item.value) + " ", 1),
                            _createVNode(_component_Icons, {
                              onClick: ($event: any) => (_ctx.onDeleteSummary(item.from)),
                              name: "icon-x",
                              class: "ml-2 w-4 text-gray-lp-600 cursor-pointer"
                            }, null, 8, ["onClick"])
                          ])
                        ]))
                      }), 128)),
                      (_ctx.summaryFilter.length)
                        ? (_openBlock(), _createBlock("p", {
                            key: 0,
                            class: "text-14px font-semibold font-montserrat cursor-pointer mb-2",
                            style: {"color":"#B82025"},
                            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onResetFilter && _ctx.onResetFilter(...args)))
                          }, " Reset "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _hoisted_26
              ]),
              _createVNode("div", _hoisted_27, [
                _createVNode(_component_DataWrapper, { class: "w-full mr-4" }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_28, [
                      _createVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.manualSttNumber")) + " ", 1),
                        _createVNode("span", _hoisted_29, "(" + _toDisplayString(_ctx.$t("optional")) + ")", 1)
                      ]),
                      (_ctx.formType === 'manual')
                        ? (_openBlock(), _createBlock("div", _hoisted_30, [
                            _createVNode("img", {
                              onMouseenter: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isOpenTooltipManualSTT = true)),
                              onMouseleave: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isOpenTooltipManualSTT = false)),
                              src: 
                    _ctx.isOpenTooltipManualSTT
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                              alt: ""
                            }, null, 40, ["src"]),
                            _withDirectives(_createVNode(_component_Tooltip, {
                              title: "STT Manual (Opsional)",
                              message: "Isi jika ingin menggunakan STT Manual.",
                              footer: "",
                              style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.6em"}
                            }, null, 512), [
                              [_vShow, _ctx.isOpenTooltipManualSTT]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_lp_input, {
                      class: "my-2",
                      error: _ctx.error.sttManual,
                      errorCaption: _ctx.errorCaptionSttManual,
                      disabled: _ctx.isDisabledSttManual,
                      onChange: _ctx.validateSttManual,
                      modelValue: _ctx.manualBooking.sttManual,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.manualBooking.sttManual = $event))
                    }, null, 8, ["error", "errorCaption", "disabled", "onChange", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.externalRefNumber'),
                  optional: !_ctx.isClientDO,
                  asterisk: _ctx.isClientDO,
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.manualBooking.referenceExternal,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.manualBooking.referenceExternal = $event)),
                      placeholder: "DOR00989",
                      errorIcon: false,
                      errorCaption: "No. Referensi eksternal wajib diisi",
                      showMaxLength: true,
                      maxLength: 100,
                      error: _ctx.errorMandatory[2],
                      onFocus: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setFieldIndex(2)))
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _: 1
                }, 8, ["label", "optional", "asterisk"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_31,
        _createVNode("div", _hoisted_32, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.shipperName'),
            asterisk: "",
            class: "w-full mr-4"
          }, {
            default: _withCtx(() => [
              (_ctx.urlVersion === 'v2')
                ? (_openBlock(), _createBlock(_component_SelectSearch, {
                    key: 0,
                    onFocus: _cache[21] || (_cache[21] = 
              e => {
                _ctx.setFieldIndex(3);
              }
            ),
                    onChange: _ctx.onChooseSenders,
                    onFilter: _cache[22] || (_cache[22] = e => _ctx.setNameCustomer(e, 'senders')),
                    placeholder: _ctx.$t('bookingShipment.placeholder.shipperName'),
                    class: "mt-2",
                    options: _ctx.senders,
                    modelValue: _ctx.manualBooking.sender,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.manualBooking.sender = $event)),
                    isLoading: _ctx.isLoadingCustomer,
                    keyName: "customerName",
                    keyValue: "customerName",
                    isShowErrorIndicator: _ctx.errorMandatory[3],
                    errorCaption: 
              _ctx.errorMandatory[3] ? _ctx.$t('bookingShipment.error.senderName') : ''
            
                  }, null, 8, ["onChange", "placeholder", "options", "modelValue", "isLoading", "isShowErrorIndicator", "errorCaption"]))
                : (_openBlock(), _createBlock(_component_LpInputSearch, {
                    key: 1,
                    class: "my-2",
                    options: _ctx.senders,
                    onFilter: _cache[24] || (_cache[24] = e => _ctx.setNameCustomer(e, 'senders')),
                    onInputFilter: _cache[25] || (_cache[25] = e => _ctx.setCustomer(e, 'senders')),
                    onFocus: _cache[26] || (_cache[26] = 
              e => {
                _ctx.setFieldIndex(3);
              }
            ),
                    isLoading: _ctx.isLoadingCustomer,
                    keyName: "customerName",
                    secondKeyName: "customerPhoneNumber",
                    keyValue: "customerName",
                    "onUpdate:modelValue": [
                      _ctx.onChooseSenders,
                      _cache[27] || (_cache[27] = ($event: any) => (_ctx.manualBooking.sender = $event))
                    ],
                    placeholder: "Masukan nama pengirim",
                    isShowErrorIndicator: _ctx.errorMandatory[3],
                    errorCaption: 
              _ctx.errorMandatory[3] ? _ctx.$t('bookingShipment.error.senderName') : ''
            ,
                    modelValue: _ctx.manualBooking.sender,
                    maxLength: 250
                  }, null, 8, ["options", "isLoading", "onUpdate:modelValue", "isShowErrorIndicator", "errorCaption", "modelValue"]))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.recipientName'),
            asterisk: "",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              (_ctx.urlVersion === 'v2')
                ? (_openBlock(), _createBlock(_component_SelectSearch, {
                    key: 0,
                    onFocus: _cache[28] || (_cache[28] = 
              e => {
                _ctx.setFieldIndex(4);
              }
            ),
                    onChange: _ctx.onChooseReceivers,
                    onFilter: _cache[29] || (_cache[29] = e => _ctx.setNameCustomer(e, 'receivers')),
                    placeholder: _ctx.$t('bookingShipment.placeholder.recipientName'),
                    class: "mt-2",
                    options: _ctx.receivers,
                    modelValue: _ctx.manualBooking.receiver,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.manualBooking.receiver = $event)),
                    isLoading: _ctx.isLoadingCustomer,
                    keyName: "customerName",
                    keyValue: "customerName",
                    isShowErrorIndicator: _ctx.errorMandatory[4],
                    errorCaption: 
              _ctx.errorMandatory[4] ? _ctx.$t('bookingShipment.error.recipientName') : ''
            
                  }, null, 8, ["onChange", "placeholder", "options", "modelValue", "isLoading", "isShowErrorIndicator", "errorCaption"]))
                : (_openBlock(), _createBlock(_component_LpInputSearch, {
                    key: 1,
                    class: "my-2",
                    options: _ctx.receivers,
                    onFilter: _cache[31] || (_cache[31] = e => _ctx.setNameCustomer(e, 'receivers')),
                    onInputFilter: _cache[32] || (_cache[32] = e => _ctx.setCustomer(e, 'receivers')),
                    onFocus: _cache[33] || (_cache[33] = 
              e => {
                _ctx.setFieldIndex(4);
              }
            ),
                    isLoading: _ctx.isLoadingCustomer,
                    keyName: "customerName",
                    secondKeyName: "customerPhoneNumber",
                    keyValue: "customerName",
                    "onUpdate:modelValue": [
                      _ctx.onChooseReceivers,
                      _cache[34] || (_cache[34] = ($event: any) => (_ctx.manualBooking.receiver = $event))
                    ],
                    placeholder: "Masukan nama penerima",
                    isShowErrorIndicator: _ctx.errorMandatory[4],
                    errorCaption: 
              _ctx.errorMandatory[4] ? _ctx.$t('bookingShipment.error.recipientName') : ''
            ,
                    modelValue: _ctx.manualBooking.receiver,
                    maxLength: 250
                  }, null, 8, ["options", "isLoading", "onUpdate:modelValue", "isShowErrorIndicator", "errorCaption", "modelValue"]))
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('bookingShipment.column.shipperPhoneNumber'),
              asterisk: "",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectPhoneCountry, {
                  column: "Pengirim",
                  error: _ctx.errorPhoneSender,
                  phone: _ctx.manualBooking.phoneSender,
                  code: _ctx.manualBooking.phoneCodeSender,
                  flag: _ctx.manualBooking.phoneFlagSender,
                  onSetPhone: _ctx.setPhoneSender,
                  onSetPhoneCode: _ctx.setPhoneCodeSender,
                  onSetPhoneFlag: _ctx.setPhoneFlagSender,
                  onSetErrorPhoneCode: _ctx.setErrorPhoneCodeSender,
                  onSetFieldIndex: _cache[35] || (_cache[35] = ($event: any) => (_ctx.setFieldIndex(5)))
                }, null, 8, ["error", "phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag", "onSetErrorPhoneCode"])
              ]),
              _: 1
            }, 8, ["label"]),
            _withDirectives(_createVNode("div", _hoisted_35, [
              _hoisted_36,
              _createTextVNode(" " + _toDisplayString(_ctx.errorPhoneSender.message), 1)
            ], 512), [
              [_vShow, 
              _ctx.errorPhoneSender.success &&
                _ctx.errorPhoneSender.message &&
                _ctx.accountIsNonForeign
            ]
            ])
          ]),
          _createVNode("div", _hoisted_37, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('bookingShipment.column.recipientPhoneNumber'),
              asterisk: "",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectPhoneCountry, {
                  column: "Penerima",
                  error: _ctx.errorPhoneReceiver,
                  phone: _ctx.manualBooking.phoneReceiver,
                  code: _ctx.manualBooking.phoneCodeReceiver,
                  flag: _ctx.manualBooking.phoneFlagReceiver,
                  onSetPhone: _ctx.setPhoneReceiver,
                  onSetPhoneCode: _ctx.setPhoneCodeReceiver,
                  onSetPhoneFlag: _ctx.setPhoneFlagReceiver,
                  onSetErrorPhoneCode: _ctx.setErrorPhoneCodeReceiver,
                  onSetFieldIndex: _cache[36] || (_cache[36] = ($event: any) => (_ctx.setFieldIndex(6)))
                }, null, 8, ["error", "phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag", "onSetErrorPhoneCode"]),
                _withDirectives(_createVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createTextVNode(" " + _toDisplayString(_ctx.errorPhoneReceiver.message), 1)
                ], 512), [
                  [_vShow, 
                _ctx.errorPhoneReceiver.success &&
                  _ctx.errorPhoneReceiver.message &&
                  _ctx.accountIsNonForeign
              ]
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createVNode("div", _hoisted_40, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.shipperAddress'),
            asterisk: "",
            class: "w-full mr-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                type: "textarea",
                modelValue: _ctx.manualBooking.addressSender,
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.manualBooking.addressSender = $event)),
                error: _ctx.isShipperAndConsigneeAddressIdentical || _ctx.errorMandatory[7],
                "error-caption": 
              _ctx.errorMandatory[7]
                ? _ctx.$t('bookingShipment.error.senderAddress')
                : this.$t('bookingShipment.error.sameOriginDestination')
            ,
                preventEnterTextArea: true,
                format: _ctx.replaceNewLine,
                placeholder: _ctx.$t('bookingShipment.placeholder.shipperAddress'),
                maxLength: _ctx.maxAddressLength,
                showMaxLength: true,
                onFocus: _cache[38] || (_cache[38] = ($event: any) => (_ctx.setFieldIndex(7)))
              }, null, 8, ["modelValue", "error", "error-caption", "format", "placeholder", "maxLength"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.recipientAddress'),
            asterisk: "",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                type: "textarea",
                modelValue: _ctx.manualBooking.addressReceiver,
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.manualBooking.addressReceiver = $event)),
                error: _ctx.isShipperAndConsigneeAddressIdentical || _ctx.errorMandatory[8],
                "error-caption": 
              _ctx.errorMandatory[8]
                ? _ctx.$t('bookingShipment.error.recepientAddress')
                : this.$t('bookingShipment.error.sameOriginDestination')
            ,
                placeholder: _ctx.$t('bookingShipment.placeholder.recipientAddress'),
                preventEnterTextArea: true,
                format: _ctx.replaceNewLine,
                maxLength: _ctx.maxAddressLength,
                showMaxLength: true,
                onFocus: _cache[40] || (_cache[40] = ($event: any) => (_ctx.setFieldIndex(8)))
              }, null, 8, ["modelValue", "error", "error-caption", "placeholder", "format", "maxLength"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_41, [
          _hoisted_42,
          _createVNode("div", _hoisted_43, [
            _createVNode("div", _hoisted_44, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAddressType, (item, index) => {
                return (_openBlock(), _createBlock("label", {
                  key: index,
                  class: 
                (_ctx.currentFieldIndex > 10.8 && !_ctx.addressTypeValue) ||
                _ctx.isErrorSelectAddressType
                  ? 'radioCustomError'
                  : 'radioCustom'
              
                }, [
                  _createVNode("input", {
                    type: "radio",
                    value: _ctx.addressTypeValue,
                    checked: _ctx.manualBooking.addressReceiverType === item.value,
                    id: item,
                    onChange: ($event: any) => (_ctx.onSelectAddressType(item.name, item.value)),
                    name: "radio-input",
                    class: "w-full whitespace-no-wrap my-2 z-10"
                  }, null, 40, ["value", "checked", "id", "onChange"]),
                  _createVNode("div", _hoisted_45, [
                    _createVNode(_component_Icons, {
                      name: item.name === 'Rumah' ? 'home-type' : 'office',
                      class: "cursor-pointer ml-2 h-6"
                    }, null, 8, ["name"]),
                    _createVNode("span", _hoisted_46, _toDisplayString(item.name), 1)
                  ])
                ], 2))
              }), 128))
            ]),
            _withDirectives(_createVNode("div", _hoisted_47, [
              _hoisted_48,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.error.addressType")), 1)
            ], 512), [
              [_vShow, 
              (_ctx.currentFieldIndex > 10.8 && !_ctx.addressTypeValue) ||
                _ctx.isErrorSelectAddressType
            ]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_49, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.districtOriginCity'),
            asterisk: "",
            class: "w-full mr-4"
          }, {
            default: _withCtx(() => [
              (
              _ctx.getAccount.accountType === 'partner' ||
                _ctx.getAccount.accountType === 'client'
            )
                ? (_openBlock(), _createBlock(_component_lp_input, {
                    key: 0,
                    modelValue: _ctx.origin.name,
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.origin.name = $event)),
                    placeholder: _ctx.$t('bookingShipment.placeholder.districtOriginCity'),
                    disabled: "",
                    error: _ctx.errorEmbargo.originCity
                  }, null, 8, ["modelValue", "placeholder", "error"]))
                : _createCommentVNode("", true),
              (_ctx.getAccount.accountType === 'internal')
                ? (_openBlock(), _createBlock(_component_SelectSearch, {
                    key: 1,
                    class: "mt-2",
                    onFilter: _ctx.fetchOriginCity,
                    isLoading: _ctx.isLoadingOriginCity,
                    options: _ctx.originCityList,
                    keyName: "name",
                    keyValue: "id",
                    placeholder: _ctx.$t('bookingShipment.placeholder.districtOriginCity'),
                    modelValue: _ctx.manualBooking.originCity,
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.manualBooking.originCity = $event)),
                    onChange: _cache[43] || (_cache[43] = 
              () => {
                _ctx.onUpdateEmbargoStatusFail();
                _ctx.setProductUpsellingcityOrigin();
                _ctx.getWoodPacking();
              }
            ),
                    isShowErrorIndicator: _ctx.errorEmbargo.originCity || _ctx.errorMandatory[9],
                    onFocus: _ctx.onFocusOriginCity,
                    errorCaption: 
              _ctx.errorMandatory[9] ? 'Kecamatan, Kota Asal wajib diisi' : ''
            ,
                    isShowErrorMessage: false
                  }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "isShowErrorIndicator", "onFocus", "errorCaption"]))
                : _createCommentVNode("", true),
              (_ctx.manualBooking.originCity?.status === 'INACTIVE')
                ? (_openBlock(), _createBlock("div", _hoisted_50, _toDisplayString(this.$t("bookingShipment.error.inactiveCity")), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.districtDestinationCity'),
            asterisk: "",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                class: "mt-1.5",
                onFilter: _ctx.fetchDestinationCity,
                isLoading: _ctx.isLoadingDestinationCity,
                options: _ctx.destinationCityList,
                keyName: "name",
                keyValue: "id",
                placeholder: 
              _ctx.$t('bookingShipment.placeholder.districtDestinationCity')
            ,
                modelValue: _ctx.manualBooking.destinationCity,
                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.manualBooking.destinationCity = $event)),
                isShowErrorIndicator: 
              _ctx.errorDestinationCity ||
                _ctx.errorEmbargo.destinationCity ||
                _ctx.errorMandatory[10]
            ,
                onFocus: _ctx.onFocusDestinationCity,
                isShowErrorMessage: false,
                errorCaption: 
              _ctx.errorMandatory[10] ? _ctx.$t('bookingShipment.error.destination') : ''
            ,
                onChange: _ctx.handleErrorDestinationCity
              }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "isShowErrorIndicator", "onFocus", "errorCaption", "onChange"]),
              (_ctx.manualBooking.destinationCity?.status === 'INACTIVE')
                ? (_openBlock(), _createBlock("div", _hoisted_51, _toDisplayString(this.$t("bookingShipment.error.inactiveCity")), 1))
                : _createCommentVNode("", true),
              (_ctx.checkVendorDestinationDistrict())
                ? (_openBlock(), _createBlock("div", _hoisted_52, [
                    _hoisted_53,
                    _hoisted_54
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _withDirectives(_createVNode(_component_WarningSlaTransportation, _mergeProps(_ctx.estimateSla, { class: "mt-1" }), null, 16), [
          [_vShow, _ctx.isShowWarningSla]
        ]),
        (_ctx.allowShowZipCode)
          ? (_openBlock(), _createBlock("div", _hoisted_55, [
              _hoisted_56,
              _createVNode("div", _hoisted_57, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.postalCode'),
                  asterisk: "",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      serverSide: false,
                      onFocus: _cache[45] || (_cache[45] = ($event: any) => (_ctx.setFieldIndex(10.5))),
                      onFilter: _ctx.setPostalCodeDestination,
                      placeholder: _ctx.$t('bookingShipment.placeholder.postalCode'),
                      class: "mt-2",
                      keyName: "name",
                      keyValue: "id",
                      options: _ctx.postalCodeDestinationOptions,
                      modelValue: _ctx.manualBooking.postalCodeDestination,
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.manualBooking.postalCodeDestination = $event)),
                      isShowErrorIndicator: 
                _ctx.currentFieldIndex > 10.5 && !_ctx.manualBooking.postalCodeDestination
              ,
                      errorCaption: 
                _ctx.currentFieldIndex > 10.5 && !_ctx.manualBooking.postalCodeDestination
                  ? _ctx.$t('bookingShipment.error.postalCode')
                  : ''
              
                    }, null, 8, ["onFilter", "placeholder", "options", "modelValue", "isShowErrorIndicator", "errorCaption"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_58, [
          _createVNode("div", _hoisted_59, [
            _createVNode("div", _hoisted_60, [
              _createVNode(_component_Checkbox, {
                id: "sender",
                modelValue: _ctx.manualBooking.isSaveSender,
                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.manualBooking.isSaveSender = $event)),
                binary: true,
                onFocus: _cache[48] || (_cache[48] = ($event: any) => (_ctx.onSaveCustomer($event, 'sender'))),
                disabled: _ctx.disableSaveSender
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode("label", {
                class: "ml-2.5",
                for: "sender",
                style: `${_ctx.disableSaveSender ? `color:#9e9e9e` : ''}`
              }, _toDisplayString(_ctx.$t("bookingShipment.action.saveShipperData")), 5)
            ])
          ]),
          _createVNode("div", _hoisted_61, [
            _createVNode("div", _hoisted_62, [
              _createVNode(_component_Checkbox, {
                id: "receiver",
                modelValue: _ctx.manualBooking.isSaveReceiver,
                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.manualBooking.isSaveReceiver = $event)),
                binary: true,
                onFocus: _cache[50] || (_cache[50] = ($event: any) => (_ctx.onSaveCustomer($event, 'receiver'))),
                disabled: _ctx.disableSaveReceiver
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode("label", {
                class: "ml-2.5",
                for: "receiver",
                style: `${_ctx.disableSaveReceiver ? `color:#9e9e9e` : ''}`
              }, _toDisplayString(_ctx.$t("bookingShipment.action.saveRecipientData")), 5)
            ])
          ])
        ]),
        _hoisted_63,
        _createVNode(_component_Title, {
          label: _ctx.$t('bookingShipment.column.itemDetails')
        }, null, 8, ["label"]),
        (_ctx.accountIsNonForeign)
          ? (_openBlock(), _createBlock(_component_BannerProductType, {
              key: 4,
              class: "mt-8"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bookingShipment.column.selectServiceType'),
          asterisk: "",
          class: "w-full mr-4 mt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_product_poster, {
              class: "mt-3",
              ref: "renderPoster",
              onChoseeProduct: _ctx.onSelectProduct,
              onSetErrorTriggered: _ctx.setErrorDestintaionProductUpselling,
              isOnePack: _ctx.isOnePack,
              isJumboPack: _ctx.isShowJumbopack,
              isFormForeign: !_ctx.accountIsNonForeign
            }, null, 8, ["onChoseeProduct", "onSetErrorTriggered", "isOnePack", "isJumboPack", "isFormForeign"]),
            (_ctx.errorProduct)
              ? (_openBlock(), _createBlock("div", _hoisted_64, [
                  _createVNode(_component_Icons, {
                    name: "warning-triangle",
                    class: " w-4"
                  }),
                  _createVNode("p", _hoisted_65, _toDisplayString(_ctx.errorProduct), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode("div", _hoisted_66, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.commodity'),
            asterisk: "",
            class: "w-1/2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                class: "mt-1.5",
                options: _ctx.commodities,
                isLoading: _ctx.isLoadingCommodity,
                onFilter: _ctx.fetchCommodityList,
                keyName: "name",
                keyValue: "code",
                placeholder: _ctx.$t('bookingShipment.placeholder.commodity'),
                modelValue: _ctx.manualBooking.commodityCode,
                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.manualBooking.commodityCode = $event)),
                isShowErrorMessage: false,
                isShowErrorIndicator: 
              _ctx.manualBooking.commodityCode?.status === 'inactive' ||
                _ctx.errorEmbargo.comodity ||
                _ctx.errorMandatory[11]
            ,
                errorCaption: 
              _ctx.manualBooking.commodityCode?.status === 'inactive'
                ? this.$t('bookingShipment.error.inactiveCommodity')
                : _ctx.errorMandatory[11]
                ? _ctx.$t('bookingShipment.error.commodity')
                : ''
            ,
                onChange: _ctx.onChangeCommodities,
                onFocus: _ctx.onFocusCommodityList
              }, null, 8, ["options", "isLoading", "onFilter", "placeholder", "modelValue", "isShowErrorIndicator", "errorCaption", "onChange", "onFocus"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("div", _hoisted_67, [
            _createVNode("div", _hoisted_68, [
              _createVNode("p", null, _toDisplayString(_ctx.$t("bookingShipment.column.insurance")), 1),
              _hoisted_69,
              _createVNode("div", _hoisted_70, [
                _createVNode("img", {
                  onMouseenter: _cache[52] || (_cache[52] = ($event: any) => (_ctx.isOpenTooltipInsurance = true)),
                  onMouseleave: _cache[53] || (_cache[53] = ($event: any) => (_ctx.isOpenTooltipInsurance = false)),
                  src: 
                  _ctx.isOpenTooltipInsurance
                    ? require('@/app/ui/assets/svg/info-red.svg')
                    : require('@/app/ui/assets/svg/info.svg')
                ,
                  alt: ""
                }, null, 40, ["src"]),
                _withDirectives(_createVNode(_component_Tooltip, {
                  title: _ctx.$t('bookingShipment.tooltip.insurance'),
                  message: _ctx.$t('bookingShipment.tooltip.insuranceMsg'),
                  footer: "",
                  style: {"width":"280px","margin-left":"2.6em","margin-top":"-2.6em"}
                }, null, 8, ["title", "message"]), [
                  [_vShow, _ctx.isOpenTooltipInsurance]
                ])
              ])
            ]),
            _createVNode(_component_Select, {
              onOpenSelect: 
              () => {
                _ctx.onOpenSelectInsurance();
                _ctx.setFieldIndex(13);
              }
            ,
              onCloseSelect: _ctx.onCloseSelectInsurance,
              isOpenMenu: _ctx.isOpenSelectInsurance,
              value: _ctx.insuranceAsDefault,
              name: _ctx.insuranceAsDefault,
              isDisabled: _ctx.disabledInsurance || _ctx.disableAsuranceOtoPack,
              onChooseSelect: _ctx.onSelectStatusInsurance,
              dataSelect: _ctx.listInsurance,
              class: "w-full whitespace-no-wrap my-1.5 z-10",
              isError: _ctx.error.insurance || _ctx.errorMandatory[13]
            }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "name", "isDisabled", "onChooseSelect", "dataSelect", "isError"]),
            (_ctx.error.insurance || _ctx.errorMandatory[13])
              ? (_openBlock(), _createBlock("p", _hoisted_71, [
                  _hoisted_72,
                  _createTextVNode(" " + _toDisplayString(_ctx.errorMandatory[13]
                ? this.$t("bookingShipment.error.insurance")
                : this.$t("bookingShipment.error.inactiveInsurance")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_73, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.itemPrice'),
            asterisk: "",
            class: "w-1/2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.manualBooking.estimationPrice,
                "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.manualBooking.estimationPrice = $event)),
                prefix: _ctx.prefixCurrency,
                format: _ctx.formatEstimationPrice,
                onKeydown: _cache[55] || (_cache[55] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                placeholder: _ctx.placeholderItemPrice,
                onChange: _ctx.fullFilledCOD,
                errorIcon: false,
                error: _ctx.errorMandatory[14] || _ctx.errorEstimationPrice,
                errorCaption: 
              _ctx.errorEstimationPrice
                ? `${_ctx.errMsgPrice}`
                : _ctx.$t('bookingShipment.error.itemPrice')
            ,
                onFocus: _cache[56] || (_cache[56] = ($event: any) => (_ctx.setFieldIndex(14)))
              }, null, 8, ["modelValue", "prefix", "format", "placeholder", "onChange", "error", "errorCaption"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.formType === 'manual' && _ctx.getAccount.accountType === 'partner')
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                class: "w-1/2 mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InfoInsurance, {
                    condition: _ctx.insuranceCondition,
                    commission: _ctx.insuranceDetail?.commissionPos,
                    profit: _ctx.insuranceProfit
                  }, null, 8, ["condition", "commission", "profit"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Woodpacking, {
          ref: "woodpacking",
          modelValue: _ctx.manualBooking.isWoodpack,
          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.manualBooking.isWoodpack = $event)),
          city: _ctx.cityForWoodPacking,
          eligibleAccess: _ctx.eligibleToWoodpacking
        }, null, 8, ["modelValue", "city", "eligibleAccess"]),
        (_ctx.codDfodClientPermission)
          ? (_openBlock(), _createBlock(_component_DeliveryTypeClient, {
              key: 5,
              ref: "deliveryType",
              modelValue: _ctx.deliveryFeeTypeClient,
              "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_ctx.deliveryFeeTypeClient = $event)),
              isCod: _ctx.typeDeliveryClientCOD,
              isDfod: _ctx.typeDeliveryClientDFOD
            }, null, 8, ["modelValue", "isCod", "isDfod"]))
          : _createCommentVNode("", true),
        (
          _ctx.formType === 'manual' &&
            _ctx.getAccount.accountType === 'partner' &&
            _ctx.accountIsNonForeign
        )
          ? (_openBlock(), _createBlock("div", _hoisted_74, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deliveryFeeTypes, (option) => {
                return (_openBlock(), _createBlock("div", {
                  key: option.value,
                  class: "flex flex-col gap-y-4 mx-2 my-4 city-exclude-radio items-center"
                }, [
                  _createVNode("div", {
                    class: 
              `p-field-radiobutton gap-x-3 flex flex-row ${
                option.logo ? 'items-center' : 'mt-3'
              }
            ${option.logo === 'dfod-logo' ? 'mt-2' : ''}`
            
                  }, [
                    _createVNode(_component_RadioButton, {
                      id: `radio-${option.value}`,
                      name: "surcharge-status",
                      value: option.value,
                      modelValue: _ctx.deliveryFeeType,
                      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_ctx.deliveryFeeType = $event)),
                      disabled: option.disabled,
                      onChange: ($event: any) => (_ctx.onChangeDeliveryFeeType(option.value))
                    }, null, 8, ["id", "value", "modelValue", "disabled", "onChange"]),
                    _createVNode("label", {
                      for: `radio-${option.value}`,
                      class: 
                `cursor-pointer flex ${option.logo ? 'items-center' : ''}`
              
                    }, [
                      (option.logo)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: require(`@/app/ui/assets/images/${option.logo}.png`),
                            class: "max-w-none w-12 mr-2",
                            alt: "cod-logo"
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true),
                      _createVNode("label", _hoisted_75, _toDisplayString(option.name), 1)
                    ], 10, ["for"])
                  ], 2)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_76, [
          (_ctx.manualBooking.isCOD || _ctx.deliveryFeeTypeClient === 'cod')
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                label: "Harga Barang COD",
                class: "w-1/2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.manualBooking.codAmount,
                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_ctx.manualBooking.codAmount = $event)),
                    prefix: "IDR",
                    disabled: _ctx.disableHargaBarangCod,
                    format: _ctx.formatEstimationPrice,
                    onKeydown: _cache[61] || (_cache[61] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                    placeholder: "0",
                    disableBackground: true,
                    onFocus: _cache[62] || (_cache[62] = ($event: any) => (_ctx.setFieldIndex(15))),
                    error: _ctx.errorMandatory[15] || _ctx.errorEstimationPrice,
                    errorCaption: 
              _ctx.errorEstimationPrice && _ctx.isEligibleCOD ? `${_ctx.errMsgPrice}` : ''
            
                  }, null, 8, ["modelValue", "disabled", "format", "error", "errorCaption"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_77, [
            (_ctx.isCodRetailApplied)
              ? (_openBlock(), _createBlock(_component_InformationCodRetail, {
                  key: 0,
                  type: _ctx.deliveryFeeType,
                  booking: "retail",
                  class: "max-h-full"
                }, null, 8, ["type"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.isFtzAccount)
          ? (_openBlock(), _createBlock("div", _hoisted_78, [
              _hoisted_79,
              _createVNode(_component_Title, {
                label: _ctx.$t('bookingShipment.column.crossBorderInformation')
              }, null, 8, ["label"]),
              _createVNode("div", _hoisted_80, [
                _createVNode("div", _hoisted_81, [
                  _createVNode("div", _hoisted_82, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t("bookingShipment.column.taxIdentificationNumber")), 1),
                    (!_ctx.accountIsNonForeign)
                      ? (_openBlock(), _createBlock("span", _hoisted_83, "*"))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_84, [
                      _createVNode("img", {
                        onMouseenter: _cache[63] || (_cache[63] = ($event: any) => (_ctx.isOpenTooltipTax = true)),
                        onMouseleave: _cache[64] || (_cache[64] = ($event: any) => (_ctx.isOpenTooltipTax = false)),
                        src: 
                    _ctx.isOpenTooltipTax
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                        alt: ""
                      }, null, 40, ["src"]),
                      _withDirectives(_createVNode(_component_Tooltip, {
                        title: _ctx.$t('bookingShipment.tooltip.tax'),
                        message: _ctx.$t('bookingShipment.tooltip.taxMsg'),
                        footer: "",
                        class: " w-200px ml-8",
                        style: {"margin-top":"-2.8em"}
                      }, null, 8, ["title", "message"]), [
                        [_vShow, _ctx.isOpenTooltipTax]
                      ])
                    ])
                  ]),
                  (_ctx.accountIsNonForeign)
                    ? (_openBlock(), _createBlock(_component_lp_input, {
                        key: 0,
                        modelValue: _ctx.manualBooking.taxNumber,
                        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_ctx.manualBooking.taxNumber = $event)),
                        format: _ctx.formatted,
                        onChange: _ctx.validateTaxNumber,
                        errorCaption: "Masukan No. Registrasi Pajak (NPWP) dengan benar",
                        error: _ctx.error.taxNumber,
                        placeholder: 
                _ctx.$t('bookingShipment.placeholder.taxIdentificationNumber')
              ,
                        maxLength: 20,
                        "show-max-length": "",
                        onBlur: _ctx.handleErrorTaxNumber,
                        onFocus: _cache[66] || (_cache[66] = ($event: any) => (_ctx.setFieldIndex(16)))
                      }, null, 8, ["modelValue", "format", "onChange", "error", "placeholder", "onBlur"]))
                    : (_openBlock(), _createBlock(_component_lp_input, {
                        key: 1,
                        modelValue: _ctx.manualBooking.taxNumber,
                        "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (_ctx.manualBooking.taxNumber = $event)),
                        placeholder: 
                _ctx.$t('bookingShipment.placeholder.taxIdentificationNumber')
              ,
                        maxLength: 20,
                        "show-max-length": "",
                        onFocus: _cache[68] || (_cache[68] = ($event: any) => (_ctx.setFieldIndex(16)))
                      }, null, 8, ["modelValue", "placeholder"]))
                ]),
                _createVNode("div", _hoisted_85, [
                  _createVNode("div", _hoisted_86, [
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.shipmentStatus")) + " ", 1),
                      (
                    (_ctx.isFtzAccount || _ctx.formType === 'client') &&
                      _ctx.accountIsNonForeign
                  )
                        ? (_openBlock(), _createBlock("span", _hoisted_87, "*"))
                        : (_openBlock(), _createBlock("span", _hoisted_88, "(" + _toDisplayString(_ctx.$t("optional")) + ")", 1))
                    ]),
                    _createVNode("div", _hoisted_89, [
                      _createVNode("img", {
                        onMouseenter: _cache[69] || (_cache[69] = ($event: any) => (_ctx.isOpenTooltipStatusGoods = true)),
                        onMouseleave: _cache[70] || (_cache[70] = ($event: any) => (_ctx.isOpenTooltipStatusGoods = false)),
                        src: 
                    _ctx.isOpenTooltipStatusGoods
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                        alt: ""
                      }, null, 40, ["src"]),
                      _withDirectives(_createVNode(_component_Tooltip, {
                        title: _ctx.$t('bookingShipment.tooltip.shipmentStatus'),
                        message: _ctx.$t('bookingShipment.tooltip.shipmentStatusMsg'),
                        footer: "",
                        style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                      }, null, 8, ["title", "message"]), [
                        [_vShow, _ctx.isOpenTooltipStatusGoods]
                      ])
                    ])
                  ]),
                  _createVNode(_component_Select, {
                    onOpenSelect: 
                () => {
                  _ctx.onOpenSelect();
                  _ctx.setFieldIndex(17);
                }
              ,
                    onCloseSelect: _ctx.onCloseSelect,
                    isOpenMenu: _ctx.isStatusGoods,
                    value: 
                _ctx.formType === 'manual'
                  ? _ctx.manualBooking.statusGoods
                  : _ctx.statusGoodValueForclients
              ,
                    onChooseSelect: _ctx.onSelectStatus,
                    dataSelect: 
                _ctx.accountIsNonForeign
                  ? _ctx.listStatusGoodsForIndonesian
                  : _ctx.listStatusGoodsForEnglish
              ,
                    class: "w-full whitespace-no-wrap my-1.5 z-10",
                    isError: _ctx.accountIsNonForeign ? _ctx.errorMandatory[17] : false
                  }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect", "isError"]),
                  (_ctx.accountIsNonForeign && _ctx.errorMandatory[17])
                    ? (_openBlock(), _createBlock("p", _hoisted_90, [
                        _hoisted_91,
                        _createTextVNode(" " + _toDisplayString(this.$t("bookingShipment.error.shipmentStatus")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.accountIsNonForeign)
                ? (_openBlock(), _createBlock("div", _hoisted_92, [
                    _createVNode("div", _hoisted_93, [
                      _createVNode("div", _hoisted_94, [
                        _hoisted_95,
                        _hoisted_96,
                        _createVNode("div", _hoisted_97, [
                          _createVNode("img", {
                            onMouseenter: _cache[71] || (_cache[71] = ($event: any) => (_ctx.isOpenTooltipPiecePerPack = true)),
                            onMouseleave: _cache[72] || (_cache[72] = ($event: any) => (_ctx.isOpenTooltipPiecePerPack = false)),
                            src: 
                    _ctx.isOpenTooltipPiecePerPack
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                            alt: ""
                          }, null, 40, ["src"]),
                          _withDirectives(_createVNode(_component_Tooltip, {
                            title: "Piece Per Pack",
                            message: "Piece per pack adalah jumlah barang yang ada dalam satu koli.",
                            footer: "",
                            style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                          }, null, 512), [
                            [_vShow, _ctx.isOpenTooltipPiecePerPack]
                          ])
                        ])
                      ]),
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.manualBooking.piecePerPack,
                        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => (_ctx.manualBooking.piecePerPack = $event)),
                        format: _ctx.formatPiecePerPack,
                        placeholder: "Masukan piece per pack",
                        errorIcon: false,
                        error: _ctx.errorMandatory[18],
                        errorCaption: "Piece per pack wajib diisi",
                        onFocus: _cache[74] || (_cache[74] = ($event: any) => (_ctx.setFieldIndex(18)))
                      }, null, 8, ["modelValue", "format", "error"])
                    ]),
                    _createVNode("div", _hoisted_98, [
                      _createVNode("div", _hoisted_99, [
                        _hoisted_100,
                        _hoisted_101,
                        _createVNode("div", _hoisted_102, [
                          _createVNode("img", {
                            onMouseenter: _cache[75] || (_cache[75] = ($event: any) => (_ctx.isOpenTooltipNextCommodity = true)),
                            onMouseleave: _cache[76] || (_cache[76] = ($event: any) => (_ctx.isOpenTooltipNextCommodity = false)),
                            src: 
                    _ctx.isOpenTooltipNextCommodity
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                            alt: ""
                          }, null, 40, ["src"]),
                          _withDirectives(_createVNode(_component_Tooltip, {
                            title: "Komoditas Selanjutnya",
                            message: "Isi dengan komoditas barang yang ada dalam satu koli.",
                            footer: "",
                            style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                          }, null, 512), [
                            [_vShow, _ctx.isOpenTooltipNextCommodity]
                          ])
                        ])
                      ]),
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.manualBooking.nextCommodity,
                        "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => (_ctx.manualBooking.nextCommodity = $event)),
                        placeholder: "Masukan komoditas selanjutnya",
                        errorIcon: false,
                        error: _ctx.errorMandatory[19],
                        errorCaption: 'Komoditas selanjutnya wajib diisi',
                        onFocus: _cache[78] || (_cache[78] = ($event: any) => (_ctx.setFieldIndex(19))),
                        onBlur: _cache[79] || (_cache[79] = ($event: any) => (_ctx.setFieldIndex(19)))
                      }, null, 8, ["modelValue", "error"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isProductInterpack && _ctx.eligibleAdditionalInfo)
          ? (_openBlock(), _createBlock(_component_AdditionalInfo, {
              onUpdateCommodity: _ctx.updateCommodity,
              onUpdateFiles: _ctx.updateFiles,
              onSetFieldIndex: _ctx.setFieldIndex,
              errorCommodity: _ctx.errorMandatory[20],
              indexErrorCommodity: 20,
              errorPhoto: _ctx.errorMandatory[21],
              indexErrorPhoto: 21,
              limitError: 22,
              currentIndexError: _ctx.currentFieldIndex,
              key: _ctx.tabKey
            }, null, 8, ["onUpdateCommodity", "onUpdateFiles", "onSetFieldIndex", "errorCommodity", "errorPhoto", "currentIndexError"]))
          : _createCommentVNode("", true),
        _hoisted_103,
        _createVNode("div", _hoisted_104, [
          _hoisted_105,
          _createVNode("div", _hoisted_106, [
            _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.grossWeight")) + " ", 1),
            _hoisted_107,
            _hoisted_108,
            _createVNode("div", _hoisted_109, [
              _createVNode("img", {
                onMouseenter: _cache[80] || (_cache[80] = ($event: any) => (_ctx.isOpenTooltipWeight = true)),
                onMouseleave: _cache[81] || (_cache[81] = ($event: any) => (_ctx.isOpenTooltipWeight = false)),
                src: 
                _ctx.isOpenTooltipWeight
                  ? require('@/app/ui/assets/svg/info-red.svg')
                  : require('@/app/ui/assets/svg/info.svg')
              ,
                alt: "",
                class: "ml-2"
              }, null, 40, ["src"]),
              _withDirectives(_createVNode(_component_Tooltip, {
                title: _ctx.$t('bookingShipment.tooltip.weight'),
                message: _ctx.$t('bookingShipment.tooltip.weightMsg'),
                footer: "",
                style: {"width":"280px","margin-left":"2.6em","margin-top":"-2.6em"}
              }, null, 8, ["title", "message"]), [
                [_vShow, _ctx.isOpenTooltipWeight]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_110, [
            _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.dimensionsPackage")) + " ", 1),
            _createVNode("span", _hoisted_111, " (" + _toDisplayString(_ctx.$t("bookingShipment.placeholder.dimensionsPackage")) + ")", 1),
            _hoisted_112
          ]),
          _createVNode("div", _hoisted_113, _toDisplayString(_ctx.$t("bookingShipment.column.dimensionWeight")), 1)
        ]),
        _createVNode("div", _hoisted_114, [
          _hoisted_115,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listKGs, (key, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "flex flex-col py-6 border-b"
            }, [
              _createVNode("div", _hoisted_116, [
                _createVNode("div", _hoisted_117, _toDisplayString(index + 1), 1),
                _createVNode("div", _hoisted_118, [
                  _createVNode(_component_lp_input, {
                    modelValue: key.grossWeight,
                    "onUpdate:modelValue": [($event: any) => (key.grossWeight = $event), ($event: any) => (_ctx.setOnValidationHws(key.grossWeight, index))],
                    format: _ctx.formatFloat,
                    onChange: _ctx.onUpdateEmbargoStatusFail,
                    placeholder: "e.g 20",
                    maxLength: _ctx.isMaxLengthGrossWeight,
                    error: _ctx.errorEmbargo.weightStatus,
                    onFocus: _cache[82] || (_cache[82] = ($event: any) => (_ctx.setFieldIndex(22)))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "onChange", "maxLength", "error"])
                ]),
                _createVNode("div", _hoisted_119, [
                  _createVNode(_component_InputDimension, {
                    length: key.dimension.length,
                    "onUpdate:length": ($event: any) => (key.dimension.length = $event),
                    width: key.dimension.width,
                    "onUpdate:width": ($event: any) => (key.dimension.width = $event),
                    height: key.dimension.height,
                    "onUpdate:height": ($event: any) => (key.dimension.height = $event),
                    onInput: ($event: any) => (_ctx.calculationVolumeWeight(index)),
                    error: _ctx.errorEmbargo.lengthStatus,
                    onChange: _ctx.onUpdateEmbargoStatusFail
                  }, null, 8, ["length", "onUpdate:length", "width", "onUpdate:width", "height", "onUpdate:height", "onInput", "error", "onChange"])
                ]),
                _createVNode("div", _hoisted_120, _toDisplayString(key.convertVolumeWeight) + " kg ", 1),
                _createVNode("div", _hoisted_121, [
                  _withDirectives(_createVNode("div", {
                    onClick: ($event: any) => (_ctx.removeKGs(index)),
                    class: "self-center cursor-pointer ml-3 relative"
                  }, [
                    _createVNode("div", {
                      class: "img-close-icon",
                      onMouseenter: ($event: any) => (_ctx.isHoverEnter(index)),
                      onMouseleave: _cache[83] || (_cache[83] = ($event: any) => (_ctx.isHoverDelete = false))
                    }, [
                      _withDirectives(_createVNode(_component_Tooltip, {
                        message: "Hapus Barang",
                        title: "",
                        footer: "",
                        style: {"width":"135px","margin-left":"1.5em","margin-top":"-1.3em"}
                      }, null, 512), [
                        [_vShow, _ctx.isHoverDelete && index === _ctx.cacheIndex]
                      ])
                    ], 40, ["onMouseenter"])
                  ], 8, ["onClick"]), [
                    [_vShow, _ctx.listKGs.length > 1]
                  ])
                ])
              ]),
              (key.errorHws)
                ? (_openBlock(), _createBlock("div", _hoisted_122, [
                    _hoisted_123,
                    _hoisted_124,
                    _createVNode("p", _hoisted_125, " Berat mulai " + _toDisplayString(_ctx.configHeavyWeightMinimum.heavyWeightMinimum) + " kg hanya 1 koli. Ubah berat atau booking baru. ", 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.showWarningHws)
            ? (_openBlock(), _createBlock("div", _hoisted_126, [
                _hoisted_127,
                _createVNode("div", _hoisted_128, [
                  _createVNode(_component_Icons, {
                    width: "16",
                    height: "16",
                    name: "announce",
                    class: "mr-2"
                  }),
                  _hoisted_129,
                  _createTextVNode(" Berat diatas " + _toDisplayString(_ctx.configHeavyWeightMinimum.heavyWeightMinimum) + " kg akan dikenakan biaya tambahan & Anda tidak dapat menambah koli lagi. ", 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isMaxAddKgs && _ctx.accountIsNonForeign)
          ? (_openBlock(), _createBlock("div", _hoisted_130, [
              (
            !_ctx.isVendorNinjaDestination &&
              !_ctx.allowToAddMoreKoli &&
              !_ctx.allowToAddMoreKoliVolume
          )
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    onClick: _cache[84] || (_cache[84] = ($event: any) => (
            _ctx.manualBooking.productName === 'INTERPACK' ||
            _ctx.showWarningHws ||
            _ctx.isErrorHws
              ? null
              : _ctx.addKGs()
          )),
                    class: 
            `flex gap-3 ${
              _ctx.manualBooking.productName === 'INTERPACK' ||
              _ctx.showWarningHws ||
              _ctx.isErrorHws
                ? 'text-gray-lp-600 cursor-not-allowed'
                : 'text-red-lp-300 cursor-pointer'
            }`
          
                  }, [
                    _createVNode(_component_Icons, {
                      name: "plus-circle",
                      class: 
              `${
                _ctx.manualBooking.productName === 'INTERPACK' ||
                _ctx.showWarningHws ||
                _ctx.isErrorHws
                  ? 'text-gray-lp-600'
                  : 'text-red-lp-300'
              }`
            
                    }, null, 8, ["class"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.action.addItems")), 1)
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAllowUploadAdjustmentFile)
          ? (_openBlock(), _createBlock(_component_UploadPhotoAdjustment, {
              key: 10,
              title: "Upload bukti foto untuk ubah berat",
              watermark: _ctx.manualBooking.referenceExternal,
              onOnUploadImage: _ctx.uploadAdjustmentFileFromComponent,
              onOnDeleteImage: _ctx.deleteAdjustmentFileFromComponent
            }, null, 8, ["watermark", "onOnUploadImage", "onOnDeleteImage"]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: 
          `my-4 bg-gray-lp-700 p-3 rounded-md flex flex-row ${
            _ctx.validateTotalGrossWeight || _ctx.validateGrossWeightJumbopack
              ? 'border border-red-lp-100'
              : ''
          }`
        
        }, [
          _createVNode("div", _hoisted_131, [
            _createVNode("div", _hoisted_132, [
              _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.totalItem")) + " ", 1),
              _createVNode("p", null, _toDisplayString(_ctx.listKGs.length), 1)
            ]),
            _createVNode("div", _hoisted_133, [
              _createVNode("div", {
                class: 
                `flex flex-row justify-between text-12px xxl:text-14px mt-4 ${
                  _ctx.isGrossWeight && !_ctx.isCampaign
                    ? 'text-gray-lp-300 font-semibold'
                    : 'text-gray-lp-600 font-normal'
                }`
              
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.totalGrossWeight")) + " ", 1),
                _createVNode("p", null, _toDisplayString(_ctx.totalGrossWeight) + " kg", 1)
              ], 2),
              (_ctx.validateTotalGrossWeight)
                ? (_openBlock(), _createBlock("div", _hoisted_134, _toDisplayString(this.$t("bookingShipment.error.weightMaximum")), 1))
                : _createCommentVNode("", true),
              (_ctx.isGrossWeight && _ctx.isCampaign)
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: 
                `flex flex-row justify-between text-12px xxl:text-14px ${
                  _ctx.isGrossWeight && _ctx.isCampaign
                    ? 'text-gray-lp-300 font-semibold'
                    : 'text-gray-lp-600 font-normal'
                }`
              
                  }, [
                    _hoisted_135,
                    _createVNode("p", null, _toDisplayString(_ctx.totalCampaignChargeableWeight.toString().replace(".", ",")) + " kg ", 1)
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_136, [
              _createVNode("div", {
                class: 
                `flex flex-row justify-between text-12px xxl:text-14px mt-4 ${
                  _ctx.isVolumeWeight && !_ctx.isCampaign
                    ? 'text-gray-lp-300 font-semibold'
                    : 'text-gray-lp-600 font-normal'
                }`
              
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.totalDimensionWeight")) + " ", 1),
                _createVNode("p", null, _toDisplayString(_ctx.totalVolumeWeight) + " kg", 1)
              ], 2),
              (_ctx.validateTotalVolumeWeight)
                ? (_openBlock(), _createBlock("div", _hoisted_137, " Total berat barang melebihi batas maksimum yaitu 400 kg/STT "))
                : _createCommentVNode("", true),
              (_ctx.isVolumeWeight && _ctx.isCampaign)
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: 
                `flex flex-row justify-between text-12px xxl:text-14px ${
                  _ctx.isVolumeWeight && _ctx.isCampaign
                    ? 'text-gray-lp-300 font-semibold'
                    : 'text-gray-lp-600 font-normal'
                }`
              
                  }, [
                    _hoisted_138,
                    _createVNode("p", null, _toDisplayString(_ctx.totalCampaignChargeableWeight.toString().replace(".", ",")) + " kg ", 1)
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _hoisted_139,
            _createVNode("div", _hoisted_140, [
              _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.chargeableWeight")) + " ", 1),
              _createVNode("p", null, _toDisplayString(_ctx.isCampaign
                  ? _ctx.totalCampaignChargeableWeight.toString().replace(".", ",")
                  : _ctx.totalChargeableWeight) + " kg ", 1)
            ]),
            (_ctx.validateGrossWeightJumbopack)
              ? (_openBlock(), _createBlock("div", _hoisted_141, " Total berat barang minimum 30 Kg/STT "))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ])
    ])),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.closeModalError,
      title: _ctx.titleErrorspesification,
      message: _ctx.errorCause,
      image: "image-modal-warning",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.isErrorAdd && _ctx.isErrorSpesificRate]
    ]),
    (_ctx.isErrorAdd && !_ctx.isErrorSpesificRate)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onCancel: _ctx.closeModalError,
          onTryAgain: _ctx.booking,
          modal: ""
        }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('Yakin Keluar Halaman?'),
      message: 
      _ctx.$t(
        'Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.'
      )
    ,
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('bookingShipment.action.buttonQuit'),
      textCancel: _ctx.$t('bookingShipment.action.buttonStay'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('Pembuatan Booking Baru Berhasil !'),
      message: `${this.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, {
      custom: _withCtx(() => [
        (_ctx.discount.isDiscount)
          ? (_openBlock(), _createBlock(_component_card, {
              key: 0,
              isShadow: false,
              class: "mt-3"
            }, {
              default: _withCtx(() => [
                _createVNode("h2", _hoisted_142, _toDisplayString(this.$t("bookingShipment.error.totalPayment")), 1),
                _createVNode("div", _hoisted_143, [
                  _createVNode("div", _hoisted_144, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalBeforeDiscount)), 1),
                  _createVNode("div", _hoisted_145, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalAfterDiscount)), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _createVNode(_component_DialogPayment, {
      onSuccessPayment: _ctx.onCloseSuccess,
      billType: "booking",
      textHeader: "Pembuatan Booking Berhasil"
    }, null, 8, ["onSuccessPayment"]),
    (_ctx.showPopupFilterClient)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 1,
          width: "w-7/12",
          showBorderTitle: false,
          showFooter: false,
          title: "Direktori klien",
          onClose: () => _ctx.onClosePopupFilter()
        }, {
          content: _withCtx(() => [
            (!_ctx.isErrorGetClient)
              ? (_openBlock(), _createBlock("div", _hoisted_146, [
                  _createVNode(_component_AdvancedFilter, {
                    "custom-max-height": "60vh",
                    "model-value": _ctx.filterClient,
                    isDisabled: false,
                    onOpened: _ctx.onOpenedAdvancedFilter,
                    onReset: ($event: any) => (
            {
            }
          ),
                    addSumFilter: _ctx.sumFilter,
                    showIconFilter: true,
                    showCountFilter: false,
                    showChevron: false,
                    isSeparateContent: "",
                    customTitleFilter: "text-14px font-semibold text-gray-lp-300"
                  }, {
                    "custom-filter": _withCtx(() => [
                      _hoisted_147,
                      _createVNode("div", _hoisted_148, [
                        _hoisted_149,
                        _createVNode(_component_SelectSearchV2, {
                          onFilter: _ctx.fetchCityDestination,
                          onFocus: _ctx.fetchCityDestination,
                          isLoading: _ctx.loadingCityDestination,
                          options: _ctx.cityDestinationData,
                          keyName: "name",
                          keyValue: "name",
                          placeholder: "Ketik & pilih kota asal klien (3LC)",
                          modelValue: _ctx.filterClient.cityOriginCode,
                          "onUpdate:modelValue": [
                            _cache[85] || (_cache[85] = ($event: any) => (_ctx.filterClient.cityOriginCode = $event)),
                            _ctx.onChangeCityDestination
                          ]
                        }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "modelValue", "onUpdate:modelValue"]),
                        _hoisted_150,
                        _hoisted_151,
                        _createVNode(_component_MultipleSelectSearch, {
                          onChange: _ctx.onChangeShipmentType,
                          status: "active",
                          class: "my-1.5",
                          options: _ctx.optionsProduct,
                          placeholder: "Pilih tipe layanan pengiriman",
                          modelValue: _ctx.filterClient.shipmentType,
                          "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => (_ctx.filterClient.shipmentType = $event))
                        }, null, 8, ["onChange", "options", "modelValue"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model-value", "onOpened", "addSumFilter"]),
                  _createVNode(_component_Search, {
                    class: "w-full",
                    onInput: _ctx.onSearchValue,
                    onClear: _ctx.clearSearch,
                    value: _ctx.searchValue,
                    placeholder: "Cari berdasarkan nama klien",
                    colorIcon: "#4D4D4D"
                  }, null, 8, ["onInput", "onClear", "value"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_152, [
              _createVNode(_component_TableV2, {
                columns: _ctx.columns,
                onRequest: _ctx.fetchClients,
                data: _ctx.clients,
                loading: _ctx.isLoadingClients,
                errorCause: _ctx.isErrorGetClient,
                isDetailAble: "",
                onClick: item => _ctx.goToDetail(item),
                paginationStyle: "v3",
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[87] || (_cache[87] = ($event: any) => (_ctx.pagination = $event)),
                pinnedSubstractHeight: "290px",
                borderTop: false,
                borderBottom: false,
                isEmpty: _ctx.isEmpty,
                bgHeader: "bg-white",
                hidePagination: ""
              }, null, 8, ["columns", "onRequest", "data", "loading", "errorCause", "onClick", "pagination", "isEmpty"])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}